import {
    collection,
    doc,
    getDocs,
    orderBy,
    query,
    serverTimestamp,
    setDoc,
  } from "firebase/firestore";
  import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
  import { db, storage } from "firebase-config";
  import { Organization, OrganizationLocation } from "../types/organization";
  
  export async function uploadOrganizationImage(file: File, path: string) {
    const storageRef = ref(storage, path);
    await uploadBytes(storageRef, file);
    return await getDownloadURL(storageRef);
  }
  
  export async function createOrganization(input: {
    id: string;
    name: string;
    logo?: string;
    backgroundImageUrl?: string;
    accentColor: string;
    gradient: [string, string];
  }) {
    const organizationRef = doc(db, "organizations", input.id);
  
    await setDoc(
      organizationRef,
      {
        ...input,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
  }
  
  export async function createOrganizationLocation(
    organizationId: string,
    input: {
      id: string;
      name: string;
      tagline: string;
      description: string;
      distanceKm: number;
      backgroundImageUrl?: string;
      logo?: string;
      links: { type: string; url: string }[];
    }
  ) {
    const locationRef = doc(
      db,
      "organizations",
      organizationId,
      "locations",
      input.id
    );
  
    await setDoc(
      locationRef,
      {
        ...input,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
  }
  
  export async function getOrganizations(): Promise<Organization[]> {
    const organizationsRef = collection(db, "organizations");
    const snapshot = await getDocs(query(organizationsRef, orderBy("name", "asc")));
  
    return snapshot.docs.map((docItem) => ({
      id: docItem.id,
      ...(docItem.data() as Omit<Organization, "id">),
    }));
  }
  
  export async function getLocationsForOrganization(
    organizationId: string
  ): Promise<OrganizationLocation[]> {
    const locationsRef = collection(db, "organizations", organizationId, "locations");
    const snapshot = await getDocs(query(locationsRef, orderBy("name", "asc")));
  
    return snapshot.docs.map((docItem) => ({
      id: docItem.id,
      ...(docItem.data() as Omit<OrganizationLocation, "id">),
    }));
  }